export default __webpack_public_path__ + "static/media/ic-attach-device.2df1ce4f.svg";